const AuthLayout = ({ children }) => (
  <main>
    {children}
  </main>
);

export default AuthLayout;
